var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeechCloud = function SvgSpeechCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    d: "M104.5 56c0 23.88-21.562 43.5-48.5 43.5a54 54 0 0 1-10.977-1.119c-7.437-1.543-15.632-1.52-22.488 2.485a17.1 17.1 0 0 1-4.474 1.823l-1.145.286c-3.097.774-5.247-3.023-2.99-5.28a5.2 5.2 0 0 0 1.277-2.087l2.06-6.383c1.04-3.22.204-6.627-1.71-9.216C10.457 73.12 7.5 64.865 7.5 56c0-23.88 21.562-43.5 48.5-43.5s48.5 19.62 48.5 43.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M33.5 71h45M33.5 56h45M33.5 41h45"
  })));
};
export default SvgSpeechCloud;